export default __webpack_public_path__ + "static/media/slider-2.8b84c518.jpg";